var ENDPOINT = 'https://fonts-api.prod.target.com/fonts/';

export { ENDPOINT };
